'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const fromEntries = (entries) => {
  return entries.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});
};

exports.fromEntries = fromEntries;
//# sourceMappingURL=fromEntries.cjs.js.map
